"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    merchDisplayAlignmentValues: ()=>merchDisplayAlignmentValues,
    merchDisplaySavingsTypeValues: ()=>merchDisplaySavingsTypeValues,
    merchDisplayVariants: ()=>merchDisplayVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const merchDisplayVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        rootSlot: 'flex flex-col gap-1',
        headerSlot: 'flex flex-wrap items-center gap-x-2 gap-y-1',
        brandSlot: 'flex h-5 min-w-6 items-center justify-center overflow-hidden',
        savingsSlot: 'text-heading5 font-bold',
        bodySlot: 'text-body3 text-neutral-10 flex',
        actionSlot: 'flex'
    },
    variants: {
        alignment: {
            left: {
                rootSlot: 'items-start text-left',
                headerSlot: 'justify-start',
                bodySlot: 'justify-start',
                actionSlot: 'justify-start'
            },
            centered: {
                rootSlot: 'items-center text-center',
                headerSlot: 'justify-center',
                bodySlot: 'justify-center',
                actionSlot: 'justify-center'
            },
            right: {
                rootSlot: 'items-end text-right',
                headerSlot: 'justify-end',
                bodySlot: 'justify-end',
                actionSlot: 'justify-end'
            }
        },
        savingsType: {
            neutral: {
                savingsSlot: 'text-priceSale-13'
            },
            benefit: {
                savingsSlot: 'text-priceSale-8'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        alignment: 'left',
        savingsType: 'neutral'
    }
});
const merchDisplayAlignmentValues = Object.keys(merchDisplayVariants.variants.alignment);
const merchDisplaySavingsTypeValues = Object.keys(merchDisplayVariants.variants.savingsType);
exports.merchDisplayAlignmentValues = __webpack_exports__.merchDisplayAlignmentValues;
exports.merchDisplaySavingsTypeValues = __webpack_exports__.merchDisplaySavingsTypeValues;
exports.merchDisplayVariants = __webpack_exports__.merchDisplayVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "merchDisplayAlignmentValues",
    "merchDisplaySavingsTypeValues",
    "merchDisplayVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
